export default "__VITE_ASSET__DPBAFTDz__"